import { useCallback, useState } from 'react';
import DataBreachService from '../../../../services/DataBreach.service';

export default function useDashboard() {
    const [circleChart, setCircleChart] = useState([]);
    const [loading, setLoading] = useState(false);
    const [summary, setSummary] = useState();
    const [groupList, setGroupList] = useState([]);

    const getCircleChart = useCallback(async (dataBreachGroupId) => {
        setLoading(true);
        try {
            const { data } = await DataBreachService.getCircleChart(
                dataBreachGroupId
            );
            if (data?.resultData) {
                setCircleChart(data.resultData);
                setLoading(false);
            } else {
                setCircleChart([]);
                setLoading(false);
            }
        } catch (error) {
            setCircleChart([]);
            setLoading(false);
        }
    }, []);

    const getSummaryDetail = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await DataBreachService.getSummaryDetail();
            if (data?.resultData) {
                setSummary(data.resultData);
                setLoading(false);
            } else {
                setSummary();
                setLoading(false);
            }
        } catch (error) {
            setSummary();
            setLoading(false);
        }
    }, []);

    const getGroupList = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await DataBreachService.getGroupList();
            if (data?.resultData) {
                const groupList = data.resultData.map((item) => ({
                    value: item.dataBreachFormGroupId,
                    label: item.dataBreachName,
                }));
                setGroupList(groupList);
                setLoading(false);
            } else {
                setGroupList([]);
                setLoading(false);
            }
        } catch (error) {
            setGroupList([]);
            setLoading(false);
        }
    }, []);

    return {
        circleChart,
        loading,
        summary,
        groupList,
        getCircleChart,
        getSummaryDetail,
        getGroupList,
    };
}
